import { Tooltip as T } from "radix-ui";
import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

/** Wrap the app once (AppProviders does). */
export const TooltipProvider = T.Provider;

export function Tooltip({
  content,
  children,
  side = "top",
  className,
}: {
  content: ReactNode;
  children: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  className?: string;
}) {
  return (
    <T.Root delayDuration={200}>
      <T.Trigger asChild>{children}</T.Trigger>
      <T.Portal>
        <T.Content
          side={side}
          sideOffset={6}
          className={cn(
            "z-50 max-w-xs rounded-md bg-fg px-2 py-1 text-xs text-bg shadow-card",
            "data-[state=delayed-open]:animate-in",
            className,
          )}
        >
          {content}
          <T.Arrow className="fill-fg" />
        </T.Content>
      </T.Portal>
    </T.Root>
  );
}
